import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { LeaveApplication, LeaveApplicationCreate, LeaveApplicationFilter } from '../data/leaveApplication';

export function createLeaveApplicationService(client: AxiosInstance) {
  return createCrudService<LeaveApplication, LeaveApplicationCreate, LeaveApplicationFilter>(
    client,
    '/hrm/LeaveApplication',
    'id',
  );
}

export type LeaveApplicationService = CrudService<LeaveApplication, LeaveApplicationCreate, LeaveApplicationFilter>;
